// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
import { v4 as uuid } from 'uuid';

import type { SuggestionHandler } from '../types';
import { DateParser, DateUtils, LocaleManager, CursorPhraseUtils } from './utils';

export const dateSuggestionHandler: SuggestionHandler = {
	type: 'date',

	detect(state, cursorPhrases) {
		const locale = LocaleManager.getSelectedLocale(state);
		const sortedPhrases = CursorPhraseUtils.sortByDescendingRangeLength(cursorPhrases);
		const match = CursorPhraseUtils.findFirstValidDatePhrase(sortedPhrases, locale);
		if (!match || !DateUtils.canInsertDateNode(state, match.phrase.from)) {
			return null;
		}
		return {
			// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
			id: uuid(),
			type: 'date',
			from: match.phrase.from,
			to: match.phrase.to,
			metadata: {
				date: match.result.date,
				matchedFormat: match.result.matchedFormat,
				trailingDelimiter: match.result.trailingDelimiter,
			},
			isPartial: !match.result.matchedFormat.includes('y'),
		};
	},

	createMarkers(suggestion) {
		const { from, to } = suggestion;
		return [
			{
				style: 'highlight',
				from,
				to,
			},
			{
				style: 'underline',
				from,
				to,
			},
		];
	},

	createCompletionHint(suggestion) {
		if (!suggestion.isPartial) {
			return null;
		}
		const { date, matchedFormat, trailingDelimiter } = suggestion.metadata;
		const formatDelimiter = DateParser.extractDelimiterFromFormat(matchedFormat);
		if (trailingDelimiter && trailingDelimiter === formatDelimiter) {
			return {
				hintText: `${date.getFullYear()}`,
			};
		} else {
			return {
				hintText: `${formatDelimiter}${date.getFullYear()}`,
			};
		}
	},

	createReplacement(suggestion, schema) {
		const { date } = suggestion.metadata;
		const timestamp = DateUtils.getDateOnlyUtcTimestamp(date);
		return schema.nodes.date.create({ timestamp: String(timestamp) });
	},
};
